var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('tabulacao-form',{attrs:{"tipo":"BASE","turma-id":_vm.$route.params.turmaId,"periodo-id":_vm.$route.params.periodoId,"voltar-para":"/admin/tabulacao/professor/base"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }